module.exports = __webpack_public_path__ + "img/EnConstruccion.53a4616e.jpg";